import { gql } from "@/__generated__/gql";

export const CREATE_PROFILE_ANSWER_MUTATION = gql(`
  mutation CreateProfileAnswer(
    $userId: ID!
    $profileQuestionId: ID!
    $answer: String!
  ) {
    createUserProfileAnswerMutation(input: {
      userId: $userId
      profileQuestionId: $profileQuestionId
      answer: $answer
    }) {
      clientMutationId
      profileAnswer {
        id
        text
        question {
          id
          text
        }
      }
      errors {
        title
        message
      }
    }
  }
`);
